import { withCurrentParams } from 'actions/utils';
import { SCENE_DELETE } from 'store/eventConstants';
import { BROADCAST_SCENE_DELETE } from 'actions/Types';

export default sceneId => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const action = {
        type: BROADCAST_SCENE_DELETE,
        request: async apiClient => {
          await apiClient.broadcast.deleteScene(
            teamId,
            eventId,
            broadcastId,
            sceneId
          );

          const {
            meeting: { attendeeResponse }
          } = getState();

          // Any other subsequent action to be performed before response is reduced
          // notify other directors
          socket.emit(SCENE_DELETE, {
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });

          return { sceneId };
        }
      };

      dispatch(action);
    }
  );
};
